import {getCollection} from '@/lib/filters/filters.js';

/**
 * @typedef {import('vuex').Commit} Commit
 * @typedef {import('vuex').Dispatch} Dispatch
 * @typedef {import('vuex').ActionContext} ActionContext
 */

const baseState = {
  collectionNames: [],
};
const baseMutations = {
  /**
   * Updates a collection in the store.
   * @param {baseState} state
   * @param {object} payload
   * @param {string} payload.name The name of the collection to update.
   * @param {object[]} payload.value The new value for the collection.
   */
  updateCollection(state, {name, value}) {
    state[name] = value;
  },
};
const baseActions = {
  /**
   * Subscribe the store to all changes.
   * @param {ActionContext} context
   */
  subscribeCollections({commit, state}) {
    const updateStoreCollection = (name) => {
      return ({payload}) => {
        return commit('updateCollection', {name, value: payload.included});
      };
    };
    state.collectionNames.forEach((name) => {
      getCollection(name).subscribe(null, updateStoreCollection(name));
    });
  },
};

const baseGetters = {
  colorFromProjectGroup: (state) => (group) => {
    const map = {
      'Pipeline': 'Black',
      // Opportunity through Due Diligence are unique groups to Acquisitions.
      // For industrial and MF projects, these groups are part of 'Pipeline'
      'Opportunity': 'Black',
      'Initial Analysis': 'Black',
      'Advanced Analysis': 'Black',
      'LOI': 'Black',
      'Best & Final': 'Black',
      'Due Diligence': 'Yellow',
      'Under Contract': 'Yellow',
      'Closed': 'Orange',
      'Under Construction': 'Orange',
      'Completed': 'Orange', // projects currently have project stage 'completed'
      'Sold': 'Gray',
      'Dropped': 'Gray',
      '3rd Party Managed': 'Brown',
      'Land Bank': 'Green',
    };

    return map[group] || 'Orange';
  },
  colorFromBuildingGroup: (state) => (group) => {
    const map = {
      'Land Bank': 'Green',
      'Complete': 'Orange', // buildings currently have building stage 'complete'
      'Construction': 'Yellow',
      'Pipeline': 'Black',
      'Preconstruction': 'Black',
      'Sold': 'Gray',
      '3rd Party Managed': 'Brown',
    };

    return map[group] || 'Orange';
  },
  colorFromCompGroup: (state) => (group) => {
    const map = {
      'Lease': 'Cyan',
      'Building Sale': 'Red',
      'Land Sale': 'Green',
    };
    return map[group] || 'Blue';
  },
};

export {
  baseState,
  baseMutations,
  baseActions,
  baseGetters,
};
